import { useState } from 'react'

import { useLocation } from 'react-router-dom'

import Terminal from '../Terminal'
import './index.scss'

// Pages that already embed the terminal inline — no floating widget there.
const EMBEDDED_ROUTES = ['/', '/about']

const FloatingTerminal = () => {
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)

  if (EMBEDDED_ROUTES.includes(pathname)) return null

  return (
    <div className="floating-terminal">
      {open && (
        <div className="terminal-float-panel" role="dialog" aria-label="Terminal">
          <Terminal onClose={() => setOpen(false)} />
        </div>
      )}
      <button
        type="button"
        className={`terminal-fab${open ? ' is-open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? 'Close terminal' : 'Open terminal'}
        aria-expanded={open}
      >
        {open ? '✕' : '>_'}
      </button>
    </div>
  )
}

export default FloatingTerminal
